const NO_INFORMATION_DEFAULT_TITLE = 'Nenhuma informação encontrada'
const CURRENT_DATE_NO_INFORMATION_TITLE = 'Nenhuma informação no momento'

export const NO_INFORMATION_TEXT = {
  scheduling: (isCurrentDate) =>
    isCurrentDate
      ? {
        title: NO_INFORMATION_DEFAULT_TITLE,
        body: 'Seu calendário não possui agendamentos ou encaixes nessa data selecionada, e nenhum histórico de cancelamento ou desistência. Assim que tiver atualizações você poderá conferir as informações nessa área.'
      }
      : {
        title: NO_INFORMATION_DEFAULT_TITLE,
        body: 'Seu calendário não possui agendamentos ou encaixes nessa data selecionada, e nenhum histórico de cancelamento ou desistência.'
      },
  billing: (isCurrentDate) =>
    isCurrentDate
      ? {
        title: CURRENT_DATE_NO_INFORMATION_TITLE,
        body: 'A data que você selecionou ainda não possui atendimentos finalizados, por isso não temos informações de faturamento para mostrar. Aguarde atualizações.'
      }
      : {
        title: NO_INFORMATION_DEFAULT_TITLE,
        body: 'A data que você selecionou não possui atendimentos finalizados, por isso não temos informações de faturamento para mostrar.'
      },
  services: (isCurrentDate) =>
    isCurrentDate
      ? {
        title: CURRENT_DATE_NO_INFORMATION_TITLE,
        body: 'A data que você selecionou ainda não possui atendimentos finalizados, por isso não temos informações de serviços para mostrar. Aguarde atualizações.'
      }
      : {
        title: NO_INFORMATION_DEFAULT_TITLE,
        body: 'A data que você selecionou não possui atendimentos finalizados, por isso não temos informações de serviços para mostrar. '
      }
}
